module.exports = __webpack_public_path__ + "img/return-code.ea3d7366.svg";